<template>
 <input placeholder="Choose conversation"/>

 <textarea></textarea>
</template>
<script>
export default {
  name: 'RealTimeChat'
}
</script>
<style></style>
